var render = function (_h,_vm) {var _c=_vm._c;return _c('portal-target',{staticClass:"map-buttons is-hidden-print",class:_vm.props.positionClass,attrs:{"name":_vm.props.name}})}
var staticRenderFns = []

export { render, staticRenderFns }